module.exports = __webpack_public_path__ + "img/PMC_2000A_1-1.de69b8b0.png";